'use strict';

(function () {
  angular
    .module('specsguardApp')
    .directive('widgetProjectOverview', widgetProjectOverview);

  function widgetProjectOverview () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/project/overview/widgets/overview/widget-project-overview.tmpl.html',
    };
  }

})();
